import React, { useState, useEffect, useRef } from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import { useHistory } from 'react-router-dom';
import ModalFrame from "../../biztran_controls/Modal_Frame";
import AddProduct from "../StockAdjustment/AddProduct";

const CreateStockAdjustment = (props) => {
    const classes = useStyles();
    const [Mode, setMode] = useState("");
    const [DocumentNo, setDocumentNo] = useState("");
    const [DocumentDate, setDocumentDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [ProductionSectionID, setProductionSectionID] = useState();
    const [TransactionStorecmb, setTransactionStorecmb] = useState();
    const [ProductionSectioncmb, setProductionSectioncmb] = useState();
    const [Remarks, setRemarks] = useState();
    const [TransactionStoreID, setTransactionStoreID] = useState();
    const [responseGetData, fetchDataGetData] = UseFetchData();
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [response, fetchData] = UseFetchData();
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);
    const history = useHistory();
    const [ProductSKUcmb, setProductSKUcmb] = useState([]);
    const [ProductID, setProductID] = useState("");
    const [Product, setProduct] = useState("");
    const [ProductSKUID, setProductSKUID] = useState("");
    const [responsProduct, fetchProductData] = UseFetchData();
    const [Descritioncmb, setDescritioncmb] = useState([]);
    const [isOpen, setOpen] = useState('');
    const [ModelCode, setModelCode] = useState('');
    const [Description, setDescription] = useState("");
    const [BookQty, setBookQty] = useState("");
    const [PhysicalQty, setPhysicalQty] = useState("");
    const [SAMQtyIn, setSAMQtyIn] = useState(0);
    const [SAMQtyOut, setSAMQtyOut] = useState(0);
    const [Productcmb, setProductcmb] = useState([]);
    // const [responceAccDtlsData, fetchAccDtlsData] = UseFetchData();

    const validationSchema = Yup.object({
        DocumentDate: Yup.string().required("Required!"),
        TransactionStoreID: Yup.string().required("Required!"),
    });




    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e) => {
        onChange && onChange(e);
    };

    const onSubmit = (values) => {
        debugger;
        var CreatedBYID = sessionStorage.UID;
        var bodyFormData = new FormData();
        bodyFormData.append("InventoryDocumentID", props.InventoryDocumentID);
        bodyFormData.append("DocumentNo", values.DocumentNo);
        bodyFormData.append("DocumentDate", values.DocumentDate);
        bodyFormData.append("TransactionStoreID", values.TransactionStoreID);
        bodyFormData.append("TransactionType", "Stock Adjustment");
        bodyFormData.append("ProductSKUID", ProductSKUID);
        bodyFormData.append("BookQty", parseInt(values.BookQty));
        bodyFormData.append("PhysicalQty", parseInt(values.PhysicalQty));
        if (SAMQtyIn != "0") {
            bodyFormData.append("SAMQty", parseInt(values.SAMQtyIn));
        } else {
            bodyFormData.append("SAMQty", parseInt(values.SAMQtyOut))
        }
        bodyFormData.append("Remarks", values.Remarks);
        bodyFormData.append("CreatedBYID", CreatedBYID);
        fetchData("StockAdjustment/Save", bodyFormData);
    };


    const GetProductData = (ProductID) => {
        debugger;
        var bodyFormData = new FormData();
        var acid = "";
        var acSid = "";
        if (ProductSKUID != undefined && ProductSKUID != "" && ProductID != undefined && ProductID != "") {
            acid = ProductID;
            acSid = ProductSKUID;
            bodyFormData.append("ProductID", acid);
            bodyFormData.append("ProductSKUID", acSid);
            fetchProductData("StockAdjustment/GetProduct", bodyFormData);
        }
    }

    const DescriptionData = React.useCallback((options) => {
        if (options !== undefined) {
            let Product = options.map((data) => (
                <option key={data.Description} value={data.ProductSKUID}>
                    {data.Description}
                </option>
            ));
            setDescritioncmb(Product);
        }
    }, []);

    const ProductData = React.useCallback((options) => {
        if (options !== undefined) {
            let Product = options.map((data) => (
                <option key={data.ProductName} value={data.ProductID}>
                    {data.ProductName}
                </option>
            ));
            setProductcmb(Product);
        }
    }, []);

    const ProductSKUData = React.useCallback((options) => {
        if (options !== undefined) {
            let Model = options.map((data) => (
                <option key={data.ModelCode} value={data.ProductSKUID}>
                    {data.ModelCode}
                </option>
            ));
            setProductSKUcmb(Model);
        }
    }, []);

    const GetComboData = () => {
        fetchComboData("StockAdjustment/ComboDataCreateSA");
    };


    useEffect(() => {
        debugger;
        GetComboData();
    }, []);


    const StoreData = (options) => {
        if (options !== undefined) {
            let Store = options.map((data) => (
                <option key={data.StoreName} value={data.StoreID}>
                    {data.StoreName}
                </option>
            ));
            setTransactionStorecmb(Store);
        }
    };


    const GetProduct = () => {
        debugger;
        setOpen(true);
        setProductID('');
        setProductSKUID('');
        setModelCode('');
        setDescription('');
        setProduct('');
        setBookQty('');
    }

    useEffect(() => {
        debugger;
        if (response.Response === true) {
            alert("Data Saved Succesfully.");
            props.PopulateData();
            props.setOpen(false);

        }
        else if (response.Response === false) {
            if (response.Message.includes("Already") === true) {
                alert(response.Message);
            } else {
                alert("Failed.");
            }
        }
    }, [response]);

    useEffect(() => {
        debugger;
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse['CmbStore'] !== undefined && ComboDataResponse['CmbStore'].length > 0) {
                StoreData(ComboDataResponse["CmbStore"]);
            } else {
                StoreData([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
            if (ComboDataResponse["Description"] !== undefined) {
                DescriptionData(ComboDataResponse["Description"]);

            }
            else {
                DescriptionData([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
            if (ComboDataResponse["Product"] !== undefined) {
                ProductData(ComboDataResponse["Product"]);

            }
            else {
                ProductData([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
            if (ComboDataResponse["ProductSKU"] !== undefined) {
                ProductSKUData(ComboDataResponse["ProductSKU"]);

            }
            else {
                ProductSKUData([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
        }
    }, [ComboDataResponse]);

    useEffect(() => {
        if (ProductSKUID != undefined && ProductSKUID != "" && ProductID != undefined && ProductID != "") {
            GetProductData(ProductID, ProductSKUID);
        }
    }, [ProductID, ProductSKUID])

    useEffect(() => {
        debugger;
        if (responseGetData !== undefined && responseGetData.length > 0) {
            setDocumentNo(responseGetData[0].DocumentNo);
            setDocumentDate(responseGetData[0].DocumentDate === null ? "" : Moment(responseGetData[0].DocumentDate).format("YYYY-MM-DD"));
            setTransactionStoreID(responseGetData[0].TransactionStoreID === null ? "" : responseGetData[0].TransactionStoreID);
            setBookQty(responseGetData[0].BookQty === null ? "" : responseGetData[0].BookQty);
            setPhysicalQty(responseGetData[0].PhysicalQty === null ? "" : responseGetData[0].PhysicalQty);
            setProductSKUID(responseGetData[0].ProductSKUID === null ? "" : responseGetData[0].ProductSKUID);
            setSAMQtyOut(responseGetData[0].SAMQtyOut === null ? "" : responseGetData[0].SAMQtyOut);
            setSAMQtyIn(responseGetData[0].SAMQtyIn === null ? "" : responseGetData[0].SAMQtyIn);
            setRemarks(responseGetData[0].Remarks === null ? "" : responseGetData[0].Remarks);

        }
    }, [responseGetData]);


    const onSelectChange = (e) => {
        debugger;
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "TransactionStoreID") {
                setTransactionStoreID(targetvalue);
            }

        }
        else {
            if (targetname === "TransactionStoreID") {
                setTransactionStoreID("");
            }
        }
    };

    // const SAMqty = (e) => {
    //     debugger;
    //     const SAM = 0;
    //     const SAMO = 0;
    //     const PhyQty = PhysicalQty;
    //     if (PhyQty < BookQty) {
    //         SAM = (BookQty) - (PhyQty);
    //         setSAMQtyIn(SAM);
    //     } else {
    //         SAM = (BookQty) - (PhyQty);
    //         setSAMQtyOut(SAMO);
    //     }
    // }

    useEffect(() => {
        debugger;
        var SAM = 0;
        var SAMO = 0;
        var PhyQty = parseInt(PhysicalQty);
        if (PhyQty < BookQty) {
            SAM = (BookQty) - (PhyQty);
            setSAMQtyOut(SAM);
            var SAMO = 0;
            setSAMQtyIn(SAMO);
        }
        else {
            SAMO = (PhyQty) - (BookQty);
            setSAMQtyIn(SAMO);
            var SAM = 0;
            setSAMQtyOut(SAM);
        }
    }, [PhysicalQty, BookQty, SAMQtyIn, SAMQtyOut])

    return (
        <div>
            <Formik
                initialValues={{
                    DocumentNo: DocumentNo,
                    DocumentDate: DocumentDate,
                    TransactionStoreID: TransactionStoreID,
                    Remarks: Remarks,
                    SAMQtyIn: SAMQtyIn,
                    SAMQtyOut: SAMQtyOut,
                    BookQty: BookQty, PhysicalQty: PhysicalQty, ProductSKUID: ProductSKUID

                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {(formik) => {
                    return (
                        <Form>
                            <Grid spacing={2} container direction="row">
                                <Grid item xs={3}>
                                    <label
                                        htmlFor={"DocumentNo"}
                                        style={{
                                            display: "block",
                                            width: "100%"
                                        }}
                                    >
                                        {"Document No:"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="DocumentNo"
                                        disabled={true}
                                        onChange={(e) => setDocumentNo(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={1.5}>
                                    <label
                                        htmlFor={"DocumentDate"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Document Date:"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="date"
                                        name="DocumentDate"
                                        disabled={true}
                                        onChange={(e) => setDocumentDate(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={3} >
                                    <label
                                        htmlFor={"TransactionStoreID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Transaction Store:"}
                                    </label>
                                </Grid>
                                <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="TransactionStoreID"
                                        options={TransactionStorecmb}
                                        onChange={onSelectChange}
                                    />
                                </Grid>
                                <Grid item xs={3} >
                                    <label
                                        htmlFor={"ProductID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Product:"}
                                    </label>
                                </Grid>
                                <Grid item xs={7} >
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="Product"
                                        value={Product}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item xs={1} style={{ marginTop: -10 }} >
                                    <BiztranControls.Button
                                        text="..."
                                        style={{ fontSize: 10 }}
                                        onClick={() => {
                                            GetProduct();
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={3} style={{ marginRight: 2 }}>
                                    <label
                                        htmlFor={"ModelCode"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"ModelCode:"}
                                    </label>
                                </Grid>
                                <Grid item xs={8} >
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="ModelCode"
                                        value={ModelCode}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item xs={3} >
                                    <label
                                        htmlFor={"ProductID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Description:"}
                                    </label>
                                </Grid>
                                <Grid item xs={8} >
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="Description"
                                        value={Description}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <label
                                        htmlFor={"BookQty"}
                                        style={{
                                            display: "block",
                                            width: "100%"
                                        }}
                                    >
                                        {"Book Qty:"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="BookQty"
                                        disabled={true}
                                        onChange={(e) => setBookQty(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={1.5}>
                                    <label
                                        htmlFor={"PhysicalQty"}
                                        style={{
                                            display: "block",
                                            width: "100%"
                                        }}
                                    >
                                        {"Physical Qty:"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="PhysicalQty"
                                        onChange={(e) => setPhysicalQty(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <label
                                        htmlFor={"SAMQty"}
                                        style={{
                                            display: "block",
                                            width: "100%"
                                        }}
                                    >
                                        {"SAMQty (IN):"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="SAMQty"
                                        disabled={true}
                                        value={SAMQtyIn}
                                        onChange={(e) => setSAMQtyIn(e.target.value)}
                                    // onChange={(e) => {
                                    //     SAMqty(e.target.value)
                                    // }}
                                    />
                                </Grid>
                                <Grid item xs={1.5}>
                                    <label
                                        htmlFor={"SAMQty"}
                                        style={{
                                            display: "block",
                                            width: "100%"
                                        }}
                                    >
                                        {"SAMQty(Out):"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="SAMQty"
                                        value={SAMQtyOut}
                                        disabled={true}
                                        onChange={(e) => setSAMQtyOut(e.target.value)}
                                    // onChange={(e) => {
                                    //     SAMqty(e.target.value)
                                    // }}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <label
                                        htmlFor={"Remarks"}
                                        style={{
                                            display: "block",
                                            width: "100%"
                                        }}
                                    >
                                        {"Remarks:"}
                                    </label>
                                </Grid>
                                <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        ref={ref}
                                        value={Remarks}
                                        name="Remarks"
                                        onChange={(e) => {
                                            setRemarks(e.target.value)
                                            handleChange()
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={2} container direction="row">
                                <Grid item xs={12}>
                                    <div style={{ width: "100%" }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignContent: "center",
                                            }}
                                        >
                                            <BiztranControls.Button
                                                text="SAVE"
                                                type="submit"
                                                startIcon={<SaveIcon />}
                                            />
                                            <BiztranControls.Button
                                                text="CLOSE"
                                                startIcon={<CloseIcon />}
                                                onClick={() => {
                                                    props.setOpen(false);
                                                }}
                                            />
                                            <ModalFrame
                                                title="Add Product"
                                                maxWidth="lg"
                                                isOpen={isOpen}
                                                headerAlign="center"
                                                setOpen={setOpen}
                                            >
                                                <AddProduct
                                                    ProductSKUID={ProductSKUID}
                                                    TransactionStoreID={TransactionStoreID}
                                                    setOpen={setOpen}
                                                    pageName={"SAM"}
                                                    setProductID={setProductID}
                                                    setProductSKUID={setProductSKUID}
                                                    setModelCode={setModelCode}
                                                    setDescription={setDescription}
                                                    setProduct={setProduct}
                                                    setBookQty={setBookQty}
                                                />
                                            </ModalFrame>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    headertext: {
        background: "#e6d8d8",
        color: "#3d3d3d",
        height: "2rem",
        paddingLeft: "30px",
        fontSize: "1.5rem",
        //marginTop: "-16px",
        marginBottom: "10px",
        marginLeft: "-24px",
        marginRight: "-24px",
        //   borderRadius: "1rem",
    },
}));

export default CreateStockAdjustment;
